module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "st-sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Introduction ")]), _c('span', {
    staticClass: "cau"
  }, [_vm._v("by Rachel Caine")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Shiny ")]), _c('span', {
    staticClass: "cau"
  }, [_vm._v("by Rachel Caine")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("In Vino Veritas ")]), _c('span', {
    staticClass: "cau"
  }, [_vm._v("by Karen Chance")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Hunt ")]), _c('span', {
    staticClass: "cau"
  }, [_vm._v("by Rachel Vincent")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Monsters ")]), _c('span', {
    staticClass: "cau"
  }, [_vm._v("by Lilith Saintcrow")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Vampires Prefer Blondes ")]), _c('span', {
    staticClass: "cau"
  }, [_vm._v("by P. N. Elrod")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Nine-Tenths of the Law ")]), _c('span', {
    staticClass: "cau"
  }, [_vm._v("by Jenna Black")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Double Dead ")]), _c('span', {
    staticClass: "cau"
  }, [_vm._v("by Cheyenne McCray")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst-ind"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "cst-ind"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "cst-ind"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "cst-ind-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("A Rose by Any Other Name Would Still Be Red ")]), _c('span', {
    staticClass: "cau"
  }, [_vm._v("by Elizabeth A. Vaughan")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Superman ")]), _c('span', {
    staticClass: "cau"
  }, [_vm._v("by Jeanne C. Stein")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst-ind"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#h1-pro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "cst-ind"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "cst-ind"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "cst-ind"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "cst-ind"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "cst-ind"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "cst-ind"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "cst-ind"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "cst-ind-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#h1-epil",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Monster Mash ")]), _c('span', {
    staticClass: "cau"
  }, [_vm._v("by Carole Nelson Douglas")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wanted: Dead or Alive ")]), _c('span', {
    staticClass: "cau"
  }, [_vm._v("by L. A. Banks")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Mist ")]), _c('span', {
    staticClass: "cau"
  }, [_vm._v("by Susan Krinard")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Beyond the Pale ")]), _c('span', {
    staticClass: "cau"
  }, [_vm._v("by Nancy Holder")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor#abt",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("About the Authors")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheeditor#edi",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("About the Editors")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Copyright Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#copy",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0